<template>
    <div>
        <load-screen-component :is-loading="isLoading"></load-screen-component>
        <page-header pageTitle="CLIENTS.DOCUMENT" :filter="true" @filter="setFilterModal"/>
        <div v-if="!items?.validations && items?.data" class="drive-docs-grid">
            <div class="card drive-doc-card" v-for="iten in items?.data" :key="iten?.id">
                <div class="drive-doc-card__main">
                    <span class="drive-doc-card__icon"><i class="icon-file"></i></span>
                    <div class="drive-doc-card__info">
                        <strong class="drive-doc-card__name" :title="iten?.name">{{ iten?.name }}</strong>
                        <small class="drive-doc-card__client">
                            <i class="icon-user pr-1"></i>{{ iten?.client?.name }}
                        </small>
                    </div>
                </div>
                <div class="drive-doc-card__footer">
                    <span class="drive-doc-card__size">
                        <i class="icon-cloud_upload pr-1"></i>{{ formatSize(iten?.file_size) }}
                    </span>
                    <div class="text-right">
                        <a type="button" data-toggle="dropdown" aria-haspopup="true"
                           aria-expanded="false"
                           style="font-size: 20px" id="listDropdown">
                            <i class="icon-more_vert" title="Opções"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right dropdown-black">
                            <div class="dropdown-item pointer text-white"
                                 data-toggle="modal" data-target="#customModalTwo" @click="setViewModal(iten)">
                                <i class="icon-info_outline mr-2 font-15"/>{{ t('ACTIONS.INFO') }}
                            </div>
                            <div @click="downloadDocument(iten)" class="dropdown-item pointer text-white">
                                <i class="icon-download mr-2 font-15"/>{{ t('CLIENTS.DOCUMENTS.DOWNLOAD') }}
                            </div>
                            <div class="dropdown-item pointer text-white" @click="documentDelete(iten.id)">
                                <i class="icon-trash-2 mr-2 font-15"/>{{ t('CLIENTS.DOCUMENTS.DELET') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card" v-else>
            <div class="card-header"></div>
            <div class="card-body pt-0">
                <div class="text-center">
                    <h5>{{ t('CLIENTS.DOCUMENTS.NOT_FOUND') }}</h5>
                </div>
            </div>
        </div>
        <modal :titleModal="modalTitle" :modalLarge="true">
            <template v-slot:title>{{ t(modalTitle) }}</template>
            <view-drive-document-component v-if="wichModal === '1'"
                                           :document-index="iten"></view-drive-document-component>
            <div v-if="wichModal === '2'">
                <div class="modal-row2 modal-height-max" id="myTabContent">
                    <div>
                        <div class="modal-body">
                            <div class="row gutters">
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                                    <div class="form-group">
                                        <label for="client_name_filter">{{ t('CLIENTS.CLIENT') }}: </label>
                                        <input type="text" id="client_name_filter" name="client_name_filter"
                                               v-model="filter.client_name" placeholder="Cliente"
                                               class="form-control">
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                                    <div class="form-group">
                                        <label for="name_archive">{{ t('DRIVE_DOCUMENTS.ARCHIVE_NAME') }}: </label>
                                        <input type="text" id="name_archive" name="name_archive"
                                               v-model="filter.name_archive" placeholder="Nome do Arquivo"
                                               class="form-control">
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                                    <div class="form-group">
                                        <label>{{ t('CLIENTS.TYPE_ANEX') }}:</label>
                                        <Select2 :settings="{width: '100%'}" :options="[
                                                {id:'nenhum', text: 'Nenhum'},
                                                ...optionsDriveType
                                                ]"
                                                 placeholder="Tipo de Anexo"
                                                 id="typeAnex" name="typeAnex"
                                                 @select="selectOptionsDrive"
                                                 v-model="filter.drive_files_type_id"
                                        ></Select2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-end">
                    <button data-cy="client_add_back" class="btn btn-secondary mr-2" type="button"
                            data-dismiss="modal">
                        {{ t('ACTIONS.CLOSE') }}
                    </button>
                    <button data-cy="client_add_back" class="btn btn-secondary mr-2" type="button"
                            data-dismiss="modal" @click="clearFilter">
                        {{ t('ACTIONS.CLEAR') }}
                    </button>
                    <button data-cy="client_add_back" class="btn btn-primary mr-2" type="button" data-dismiss="modal"
                            @click="index(filter)">
                        {{ t('ACTIONS.FILTER') }}
                    </button>
                </div>
            </div>
        </modal>
        <pagination-component v-if="items && items.data && items.data[0]" :items="items" :to="'/documentos'"
                              @changePage="index(filter, $event)"></pagination-component>
    </div>
</template>

<script>
import PageHeader from "@/components/layouts/pageHeader";
import LoadScreenComponent from "@/components/layouts/loadScreenComponent";
import {mapState} from "vuex";
import Drive from "../../services/Drive";
import {useToast} from "vue-toastification";
import {useI18n} from "vue-i18n";
import Modal from "@/components/modal";
import viewDriveDocumentComponent from "./viewDriveDocumentComponent";
import PaginationComponent from "@/components/layouts/PaginationComponent";
import DriveFilesType from '../../services/DriveFilesType';
import Select2 from 'vue3-select2-component';

export default {
    name: "indexDriveDocumentsComponent",
    components: {
        PageHeader,
        LoadScreenComponent,
        Modal,
        viewDriveDocumentComponent,
        PaginationComponent,
        Select2,
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    computed: {
        ...mapState({
            isLoading: 'isLoading'
        })
    },
    data() {
        return {
            items: null,
            modalTitle: '',
            iten: {},
            filter: {},
            optionsDriveType: [],
        }
    },
    mounted() {
        this.index();
    },
    methods: {
        selectOptionsDrive({id}){
            if(id === 'nenhum'){
                delete this.filter.drive_files_type_id;
            }
        },
        listFilesType() {
            DriveFilesType.list().then((resp) => {
                if (resp?.data?.length) {
                    resp.data.forEach((i) => {
                        this.optionsDriveType.push({id: i.id, text: i.text})
                    })
                }
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                this.$store.commit('changeLoading', false);
            })
        },
        clearFilter() {
            this.filter = {};
            this.index();
        },
        setFilterModal() {
            this.listFilesType();
            this.$store.commit('changeLoading', true);
            this.modalTitle = 'DRIVE_DOCUMENTS.FILTER'
            this.wichModal = '2';
        },
        index(filter = {}, page = 1) {
            this.$store.commit('changeLoading', true);
            Drive.index(filter, page).then((resp) => {
                this.items = resp.data;
                this.$store.commit('changeLoading', false);
            }).catch(() => this.$store.commit('changeLoading', false));
        },
        formatSize(fileSize) {
            if (!fileSize) return '0.0';
            if (fileSize < 1000) return `${fileSize} Bytes`;
            if (fileSize > 1000 && fileSize < 1000000) return `${(fileSize / 1000).toFixed()} KB`;
            if (fileSize >= 1000000 && fileSize < 1000000000) return `${(fileSize / 1000000).toFixed(2)} MB`;
            if (fileSize >= 1000000000) return `${(fileSize / 1000000000).toFixed(2)} GB`;
        },
        async downloadDocument(doc) {
            this.$store.commit('changeLoading', true);
            await Drive.download(doc.id).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data], {
                    type: 'application/pdf'
                }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', doc.name);
                link.click();
                this.$store.commit('changeLoading', false);
            }).catch(() => this.$store.commit('changeLoading', false));
        },
        setViewModal(iten) {
            this.$store.commit('changeLoading', true);
            this.modalTitle = 'CLIENTS.DOCUMENTS.VIEW'
            this.iten = iten;
            this.wichModal = '1';
            this.$store.commit('changeLoading', false);
        },
        documentDelete(id) {
            this.$store.commit('changeLoading', true);
            Drive.fileDelete(id).then(() => {
                this.toast.success(this.t('CLIENTS.DOCUMENTS.DELETE_SUCCESSFULL'));
                this.index();
            }).catch(err => {
                this.errorMsg(err);
                this.$store.commit('changeLoading', false);
            }).finally(() => this.$store.commit('changeLoading', false));
        }
    }
}
</script>

<style scoped>
.drive-docs-grid {
    display: grid;
    gap: 0.75rem;
    grid-template-columns: repeat(auto-fit, minmax(270px, 1fr));
}

.drive-doc-card {
    border-radius: 14px;
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0.9rem 0.95rem;
}

.drive-doc-card__main {
    align-items: flex-start;
    display: flex;
    gap: 0.75rem;
}

.drive-doc-card__icon {
    align-items: center;
    background: #e7f4f0;
    border-radius: 12px;
    color: #0e5e4e;
    display: inline-flex;
    flex: 0 0 42px;
    font-size: 1.05rem;
    height: 42px;
    justify-content: center;
    width: 42px;
}

.drive-doc-card__info {
    min-width: 0;
}

.drive-doc-card__name {
    color: #173b34;
    display: block;
    font-size: 0.9rem;
    font-weight: 800;
    line-height: 1.25;
    margin-bottom: 0.2rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.drive-doc-card__client {
    align-items: center;
    color: #6b7c78;
    display: flex;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.drive-doc-card__footer {
    align-items: center;
    border-top: 1px solid rgba(14, 94, 78, 0.10);
    display: flex;
    justify-content: space-between;
    margin-top: 0.75rem;
    padding-top: 0.6rem;
}

.drive-doc-card__size {
    background: #e7f4f0;
    border-radius: 999px;
    color: #0e5e4e;
    display: inline-flex;
    align-items: center;
    font-size: 0.72rem;
    font-weight: 800;
    padding: 0.4rem 0.7rem;
    white-space: nowrap;
}

html.dark-theme .drive-doc-card {
    border-color: var(--dark-border) !important;
}

html.dark-theme .drive-doc-card__icon {
    background: var(--dark-primary-soft) !important;
    color: #5eead4 !important;
}

html.dark-theme .drive-doc-card__name {
    color: var(--dark-text) !important;
}

html.dark-theme .drive-doc-card__client {
    color: var(--dark-text-muted) !important;
}

html.dark-theme .drive-doc-card__footer {
    border-top-color: rgba(94, 234, 212, 0.12) !important;
}

html.dark-theme .drive-doc-card__size {
    background: var(--dark-primary-soft) !important;
    color: var(--dark-primary) !important;
}
</style>